<template>
	<div class="row upload-btn-wrapper" :class="!showDescription ? 'w-50' : ''">
		<!-- Файл -->
		<div class="form-group" :class="showDescription ? 'col-lg-6' : 'col-lg-12'">
			<div class="input-group">
				<input type="file" :name="name" :id="'file' + _uid" @change="fileChanged" class="col-lg-12" :accept="accept" />
				<input type="text" class="form-control pl-1" disabled v-model="file.fileName" :title="file.fileName" />
				<span class="input-group-append pointer">
					<span class="input-group-text bg-primary text-white px-2">
						<i class="fas fa-file-upload"></i>
					</span>
				</span>
			</div>
		</div>
		<!-- Дата -->

		<!-- Описание -->
		<div class="col-lg-6" v-if="showDescription">
			<input type="text" class="form-control" :placeholder="$t('description')" v-model="file.fileDescription" />
		</div>
	</div>
</template>

<script>
import { File } from '../../models/file.models';

export default {
	props: {
		name: {
			type: String,
			default: 'files'
		},
		file: {
			type: File,
			default: () => new File({})
		},
		showDescription: {
			type: Boolean,
			default: true
		},
        accept: {
            type: String,
            default: 'image/jpg,image/jpeg,application/pdf,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        }
	},
	methods: {
		fileChanged(event) {
			if (event.target.files.length > 0) {
                if (event.target.files[0].size > this.$store.getters.fileSizeLimit) { // 10 MB
                    this.$vs.notify({
                        title: this.$t('notifications.error'),
                        text: this.$t('notifications.fileSizeLimitExceeded', { maxSize: this.$store.getters.fileSizeLimit / 1048576 }),
                        color: 'danger',
                    });
                    return;
                }
				this.file.content = event.target.files[0];
				this.file.fileName = event.target.files[0].name;
			}
		},
		removeFile(event) {
			$('#file' + this._uid).val('');
			this.file.fileName = '';
			this.file.fileDescription = '';
			this.$emit('removeFile', this._uid);
		}
	}
};
</script>

<style scoped>
.upload-btn-wrapper {
	position: relative;
	overflow: hidden;
}

.upload-btn-wrapper input[type='file'] {
	font-size: 100px;
	position: absolute;
	left: 20px;
	top: 0;
	opacity: 0;
	cursor: pointer;
}

.pointer:hover {
	cursor: pointer;
}
</style>
